function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M104 208C161.438 208 208 161.438 208 104C208 46.5624 161.438 0 104 0C46.5624 0 0 46.5624 0 104C0 161.438 46.5624 208 104 208Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M85.6702 41.1851H163.309C167.432 41.1851 170.774 44.5276 170.774 48.6502V156.151C170.774 160.273 167.432 163.616 163.309 163.616H85.6702C81.5476 163.616 78.2051 160.273 78.2051 156.151V48.6502C78.2051 44.5276 81.5466 41.1851 85.6702 41.1851Z",
  fill: "url(#paint0_linear_232_1754)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M164.803 157.891H84.1772C84.041 157.891 83.9297 157.779 83.9297 157.643V47.1567C83.9297 47.0205 84.0399 46.9092 84.1772 46.9092H164.803C164.939 46.9092 165.051 47.0194 165.051 47.1567V157.643C165.051 157.779 164.939 157.891 164.803 157.891ZM84.4247 157.397H164.557V47.4043H84.4247V157.397Z",
  fill: "#EAEAF3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M157.148 94.9354H89.96V97.9212H157.148V94.9354Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M157.148 103.894H89.96V106.88H157.148V103.894Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M157.148 112.852H89.96V115.838H157.148V112.852Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M157.149 54.6219H134.753V57.6077H157.149V54.6219Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M157.149 60.5946H134.753V63.5804H157.149V60.5946Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  d: "M157.149 66.5673H134.753V69.5531H157.149V66.5673Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_10",
  d: "M157.148 77.0182H89.96V80.0041H157.148V77.0182Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_11",
  d: "M157.148 85.9768H89.96V88.9626H157.148V85.9768Z",
  fill: "#EAEAF3"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Vector_12",
  d: "M72.9767 45.7486C93.3056 45.7486 109.845 62.2877 109.845 82.6166C109.845 102.945 93.3056 119.485 72.9767 119.485C52.6479 119.485 36.1087 102.945 36.1087 82.6166C36.1087 62.2877 52.6479 45.7486 72.9767 45.7486ZM72.9767 41.5324C50.2871 41.5324 31.8926 59.9258 31.8926 82.6166C31.8926 105.307 50.286 123.701 72.9767 123.701C95.6675 123.701 114.061 105.307 114.061 82.6166C114.061 59.9258 95.6675 41.5324 72.9767 41.5324Z",
  fill: "#969BB7"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_13",
  d: "M60.478 101.683H54.5146C53.7637 101.683 53.1543 101.073 53.1543 100.323V96.4465H61.8383V100.323C61.8383 101.073 61.2289 101.683 60.478 101.683Z",
  fill: "#969BB7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_14",
  d: "M84.9082 101.683H90.8715C91.6224 101.683 92.2318 101.073 92.2318 100.323V96.4465H83.5479V100.323C83.5479 101.073 84.1573 101.683 84.9082 101.683Z",
  fill: "#969BB7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_15",
  d: "M93.2797 73.9534L89.7208 76.4223L87.6377 67.7862C87.2113 66.0171 85.6773 64.7754 83.9176 64.7754H75.3927H70.1574H61.6325C59.8728 64.7754 58.3388 66.0161 57.9124 67.7862L55.7971 76.5565L52.0447 73.9523C50.8685 73.137 49.2939 74.0137 49.2939 75.4842V77.142C49.2939 77.506 49.5768 77.8003 49.9263 77.8003H55.2178L52.8383 80.6884C51.636 82.1475 50.9819 83.9602 50.9819 85.8281V93.0166C50.9819 95.4034 52.9745 97.3378 55.432 97.3378H70.044H75.3387H89.9507C92.4082 97.3378 94.4008 95.4034 94.4008 93.0166V85.8281C94.4008 83.9592 93.7456 82.1465 92.5444 80.6884L90.1649 77.8003H95.3971C95.7466 77.8003 96.0295 77.506 96.0295 77.142V75.4842C96.0305 74.0147 94.4559 73.138 93.2797 73.9534Z",
  fill: "url(#paint1_linear_232_1754)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_16",
  d: "M61.2512 87.022H54.122C53.7247 87.022 53.4033 86.7006 53.4033 86.3034V84.4938C53.4033 82.889 55.1921 81.9312 56.5275 82.8214L61.5164 86.1474C61.9095 86.4094 61.7233 87.022 61.2512 87.022Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_17",
  d: "M56.411 95.1694C55.8119 95.1694 55.3252 94.6837 55.3252 94.0836C55.3252 93.4846 55.8109 92.9978 56.411 92.9978C57.01 92.9978 57.4967 93.4835 57.4967 94.0836C57.4967 94.6837 57.01 95.1694 56.411 95.1694Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_18",
  d: "M83.3579 66.9469H62.0275C60.9833 66.9469 60.0619 67.6946 59.7623 68.7877L57.5222 76.9402C57.4047 77.3698 57.699 77.8024 58.1098 77.8024H70.5097H74.8777H87.2776C87.6884 77.8024 87.9827 77.3698 87.8642 76.9402L85.624 68.7877C85.3235 67.6957 84.402 66.9469 83.3579 66.9469Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_19",
  d: "M84.3003 87.022H91.4296C91.8268 87.022 92.1482 86.7006 92.1482 86.3034V84.4938C92.1482 82.889 90.3594 81.9312 89.024 82.8214L84.0352 86.1474C83.6431 86.4094 83.8282 87.022 84.3003 87.022Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_20",
  d: "M78.8878 86.4864H75.2926H70.26H66.6637C66.1728 86.4864 65.8369 86.8878 66.0189 87.257L67.3626 89.9766C67.6163 90.4914 68.2331 90.8284 68.9174 90.8284H70.259H75.2915H76.6331C77.3175 90.8284 77.9331 90.4904 78.1879 89.9766L79.5316 87.257C79.7136 86.8878 79.3787 86.4864 78.8878 86.4864Z",
  fill: "#969BB7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_21",
  d: "M83.7714 92.9989H75.3942H70.1589H61.7817C61.2034 92.9989 60.7344 93.4846 60.7344 94.0846C60.7344 94.6837 61.2034 95.1704 61.7817 95.1704H70.1589H75.3942H83.7714C84.3497 95.1704 84.8187 94.6847 84.8187 94.0846C84.8187 93.4846 84.3497 92.9989 83.7714 92.9989Z",
  fill: "#969BB7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_22",
  d: "M88.9754 95.1694C89.5744 95.1694 90.0612 94.6837 90.0612 94.0836C90.0612 93.4846 89.5755 92.9978 88.9754 92.9978C88.3764 92.9978 87.8896 93.4835 87.8896 94.0836C87.8896 94.6837 88.3753 95.1694 88.9754 95.1694Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  id: "Vector_23",
  d: "M72.9773 50.7073C90.3681 50.7073 104.517 65.0219 104.517 82.6166C104.517 100.211 90.3681 114.526 72.9773 114.526C55.5864 114.526 41.4382 100.211 41.4382 82.6166C41.4382 65.0219 55.5864 50.7073 72.9773 50.7073ZM72.9773 48.5992C54.3945 48.5992 39.3291 63.829 39.3291 82.6166C39.3291 101.404 54.3935 116.634 72.9773 116.634C91.561 116.634 106.625 101.404 106.625 82.6166C106.625 63.829 91.561 48.5992 72.9773 48.5992Z",
  fill: "#EAEAF3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_24",
  d: "M72.663 163.616C69.6844 163.616 67.2695 161.201 67.2695 158.222V122.029H78.0575V158.222C78.0564 161.201 75.6415 163.616 72.663 163.616Z",
  fill: "#969BB7"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_232_1754",
  x1: 170.775,
  y1: 102.4,
  x2: 78.2047,
  y2: 102.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.000111817,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4442,
  stopColor: "#F9F9FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAEAF3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_232_1754",
  x1: 83.4589,
  y1: 101.796,
  x2: 61.7232,
  y2: 64.1492,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BABED1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9399B5"
})));

var SvgNoVehicles = function SvgNoVehicles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoVehicles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-vehicles.d47d8f19.svg";
export { ForwardRef as ReactComponent };